import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Tracking
        {
          name: 'Tracking-Cockpit',
          path: 'tracking/routing',
          component: () => import('@/views/dashboard/tracking/Routing'),
          children: [
            {
              name: 'Devices',
              path: 'Devices',
              component: () => import('@/views/dashboard/tracking/component/Devices'),
            },
          ],
        },
        // Print Tracked Devices
        {
          name: 'Dokumenten-Verwaltung',
          path: 'tracking/routingprint',
          component: () => import('@/views/dashboard/tracking/RoutingPrint'),
          children: [
            {
              name: 'DevicesPrint',
              path: 'DevicesPrint',
              component: () => import('@/views/dashboard/tracking/component/DevicesPrint'),
            },
          ],
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/authentication/Login'),
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
